import { PremiumType } from "../../../../types/types";

// The line slots in display order (Hull incl. Hull basic, fleet legal / hull on
// land / machinery breakdown incl. their closing date variants).
export const LINE_SLOTS: PremiumType[] = [
  PremiumType.HORSE_POWER,
  PremiumType.MTPL,
  PremiumType.HULL,
  PremiumType.ACCIDENT,
  PremiumType.ASSISTANCE,
  PremiumType.LEGAL,
  PremiumType.FLEETLEGAL_PRORATA,
  PremiumType.HULL_ON_LAND_PRORATA,
  PremiumType.MACHINERY_BREAKDOWN_PRORATA,
];
// width of an icon button and of an empty slot
export const SLOT_WIDTH = 32;

/**
 * Width fitting all slots the cell can show for a country: history,
 * the possible insurance lines, indemnity and bonus-malus.
 */
export const getInsuranceLineIconsColumnWidth = (
  premiumDomains: PremiumType[] | undefined,
  hasVehicleHistory: boolean | undefined,
) =>
  ((hasVehicleHistory ? 1 : 0) +
    LINE_SLOTS.filter((d) => !premiumDomains || premiumDomains.includes(d))
      .length +
    2) *
  SLOT_WIDTH;
